import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslations from "./locales/en.json";
import daTranslations from "./locales/da.json";

const resources = {
  en: {
    translation: enTranslations,
  },
  da: {
    translation: daTranslations,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: "en", // Default language if detection fails
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Language detection options
    detection: {
      // Order of detection methods
      order: ["localStorage", "navigator", "htmlTag"],
      // Cache user language
      caches: ["localStorage"],
      // Look for language in these places
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
